import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import { AGENT_AUTH_TOKEN_KEY } from '@/store/types'

import Error from '@/views/Error.vue'
// import Replay from '@/views/Replay.vue'

import AgentRoutes from './agent'
import VerificationRoutes from './verification'
import ThirdPartyVerifierRoutes from './third_party_verifier'
import ConfigRoutes from './config'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    VerificationRoutes,
    AgentRoutes,
    ThirdPartyVerifierRoutes,
    ConfigRoutes,
    // {
    //   path: '/replay',
    //   name: 'replay',
    //   component: Replay,
    // },
    {
      path: '/error/:code?',
      name: 'error',
      component: Error,
    },
    {
      path: '/:catchAll(.*)',
      name: '404',
      component: Error,
    },
  ],
})

/* Route Guard */
router.beforeEach(async (to, from, next) => {
  if (to.matched.some((route) => route.meta.requireAuth)) {
    const token = localStorage.getItem(AGENT_AUTH_TOKEN_KEY) || store.getters.isAuthenticated
    if (!token) {
      next({ name: 'agent_login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

// Reload on import error
router.onError((error, to) => {
  if (
    error.message.includes('Failed to fetch dynamically imported module') ||
    error.message.includes('Importing a module script failed')
  ) {
    console.log(error)
    window.location = to.fullPath
  }
})

export default router
